import React, { useEffect, useState } from "react";
import { Button, Progress } from "reactstrap";

import Icon from "../Icon/Icon";

import s from "./DownloadProgress.module.scss";

export default function DownloadProgress({
	title,
	keyFile,
	keyData,
	fileName,
	color = "success",
	disableDownload = false,
	onDownloadComplete = () => {},
}) {
	const [downloadProgress, setDownloadProgress] = useState(0);
	const [downloadStarted, setDownloadStarted] = useState(false);
	const [counter] = useState(0);

	useEffect(() => {
		if (disableDownload) return;

		// Load file content & download
		if (keyFile) {
			fetch(keyFile)
				.then((t) => t.text())
				.then((pk) => {
					download(pk);
				});
			// Just download
		} else if (keyData) {
			download(keyData);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [keyFile, keyData]);

	useEffect(() => {
		const updateProgress = () => setDownloadProgress(downloadProgress + 10);
		if (downloadProgress < 100) {
			setTimeout(updateProgress, 10);
		}
	}, [downloadProgress]);

	// ------------------------------------- METHODS -------------------------------------
	const download = (fileData) => {
		if (!downloadStarted) {
			setDownloadStarted(true);
			const data = new Blob([fileData], { type: "text/plain" });

			let hlink = document.createElement("a");
			hlink.href = URL.createObjectURL(data);
			hlink.download = fileName + (counter > 0 ? counter : "");
			hlink.click();

			onDownloadComplete(fileData);
		}
	};

	const restartDownload = () => {
		setDownloadProgress(0);
		setDownloadStarted(0);
		download();
	};

	return (
		<div className={s.root}>
			<div className={s.section}>
				<div className={s.titleContainer}>
					<Icon icon="lock" className={s.lock} />

					<div className={s.title}>{title}</div>
				</div>
			</div>

			<div>
				<Button
					onClick={restartDownload}
					color="link"
					className={s.downloadBtn}
				>
					<p className={s.downloadText}>
						Download didn’t start? Click here to try again
					</p>
				</Button>
			</div>

			<div className={s.progress}>
				<Progress value={downloadProgress} color={color} />
			</div>
		</div>
	);
}
